// import { Component } from '@angular/core';import { RouterOutlet } from '@angular/router';@Component({selector:'app-root',standalone:true,imports:[RouterOutlet],template:'<router-outlet></router-outlet>'})export class AppComponent{}



import {
  Component,
  OnInit
} from '@angular/core';

import {
  Router,
  RouterOutlet
} from '@angular/router';


@Component({
  selector: 'app-root',

  standalone: true,

  imports: [
    RouterOutlet
  ],

  template:
    '<router-outlet></router-outlet>'
})
export class AppComponent
  implements OnInit {

  constructor(
    private router: Router
  ) {}


  ngOnInit(): void {
    this.redirectSubdomainToRestaurant();
  }


  private redirectSubdomainToRestaurant(): void {

    const hostname =
      window.location.hostname
        .toLowerCase()
        .trim();


    /*
     * HML principal:
     *
     * hml.meumenuapp.com.br
     *
     * NÃO deve ser tratado como restaurante.
     */
    if (
      hostname ===
      'hml.meumenuapp.com.br'
    ) {
      return;
    }


    /*
     * Exemplo:
     *
     * pizzaria-central.hml.meumenuapp.com.br
     */
    const hmlDomain =
      '.hml.meumenuapp.com.br';


    if (
      hostname.endsWith(
        hmlDomain
      )
    ) {

      const restaurantSlug =
        hostname.substring(
          0,
          hostname.length -
          hmlDomain.length
        );


      /*
       * Evita valores inválidos.
       */
      if (
        !restaurantSlug ||
        restaurantSlug === 'www'
      ) {
        return;
      }


      /*
       * Evita redirecionar novamente
       * caso já esteja no cardápio correto.
       */
      const expectedPath =
        `/cardapio/${restaurantSlug}`;


      if (
        window.location.pathname
          .startsWith(
            expectedPath
          )
      ) {
        return;
      }


      /*
       * Redireciona internamente
       * para o cardápio do restaurante.
       */
      this.router.navigate(
        [
          '/cardapio',
          restaurantSlug
        ],
        {
          replaceUrl: true
        }
      );

    }

  }

}